import React from "react";
import ReactColorPicker from "rc-color-picker";
import "rc-color-picker/assets/index.css";
import { useField } from "formik";
import { Button, Space } from "@masterteam/mt-design-react";
import styles from "./ColorPicker.module.scss";

function ColorPicker({ name }) {
  const [field, meta, helpers] = useField({ name });
  return (
    <ReactColorPicker
      color={field.value}
      onChange={e => helpers.setValue(e.color)}
      enableAlpha={false}
    >
      <div className={styles.container}>
        <Button
          fill="outline"
          variant={meta.error ? "error" : "light"}
          color={field.value}
        >
          <Space align="center">
            <div
              className={styles.preview}
              style={{
                background: field.value
              }}
            />
            <span style={{ fontWeight: "bold" }}>{field.value}</span>
          </Space>
        </Button>
      </div>
    </ReactColorPicker>
  );
}

export default ColorPicker;
